"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserIdFromToken = void 0;
const jose_1 = require("jose");
const getUserIdFromToken = (token) => {
    const payload = (0, jose_1.decodeJwt)(token);
    const hasuraClaims = payload["https://hasura.io/jwt/claims"];
    const userId = hasuraClaims ? hasuraClaims["x-hasura-user-id"] : "";
    return userId;
};
exports.getUserIdFromToken = getUserIdFromToken;
//# sourceMappingURL=getUserIdFromToken.js.map